<template>
  <div class="yixi-app-page page-container">
    <!-- 顶部一席介绍 -->
    <section class="app-hero">
      <div class="hero-content content">
        <div class="app-icon">
          <img src="../assets/imgs/app/yixi_logo_512.png" alt="一席" />
        </div>
        <div class="app-info">
          <h1 class="app-name">一席</h1>
          <p class="app-slogan">思考现实与想象未来的演讲平台</p>
          <p class="app-subtitle">人文 · 科技 · 白日梦</p>
          <p class="app-meta">免费 · App 内购买 · 官方认证</p>
        </div>
      </div>
    </section>

    <!-- App Store 风格信息栏 -->
    <section class="app-stats content">
      <div class="stat-item">
        <div class="stat-label">下载</div>
        <div class="stat-value">346万</div>
        <div class="stat-unit">次</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">年龄</div>
        <div class="stat-value">4+</div>
        <div class="stat-unit">岁</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">开发者</div>
        <div class="stat-unit">一席话（北京）文化传媒有限公司</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">语言</div>
        <div class="stat-value">ZH</div>
        <div class="stat-unit">简体中文</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">大小</div>
        <div class="stat-unit size-line">iOS（62.8M）</div>
        <div class="stat-unit size-line">安卓（118M）</div>
      </div>
    </section>

    <!-- 下载入口 -->
    <section class="app-download content">
      <div class="download-text">
        <h2 class="download-title">一席 App 扫码下载</h2>
        <p class="download-subtitle">
          或下载安装包
          <span class="safe-tag">
            <svg class="safe-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
            </svg>
            安全 · 无广告 · 官方认证
          </span>
        </p>
        <div class="download-btns">
          <a class="download-btn" href="https://itunes.apple.com/cn/app/yi-xi/id912814691?mt=8" target="_blank">
            <span>iOS版本</span>
            <img class="btn-icon" src="../assets/imgs/app/down.png" alt="下载" />
          </a>
          <a class="download-btn" href="https://alicdn.yixi.tv/yixiapp/yixi_comm_547002.apk" download>
            <span>安卓版本</span>
            <img class="btn-icon" src="../assets/imgs/app/down.png" alt="下载" />
          </a>
        </div>
      </div>
      <div class="download-qrcode">
        <div class="qrcode-img">
          <img src="../assets/imgs/qrcode/appDownload.png" alt="下载一席APP" />
        </div>
        <p class="qrcode-tip">扫码下载</p>
      </div>
    </section>

    <!-- 图片预览 -->
    <section class="app-screenshots content">
      <h2 class="section-title">预览</h2>
      <div class="screenshots-list">
        <div class="screenshot-card" v-for="(img, index) in screenshots" :key="index">
          <img :src="img" alt="一席App截图" />
        </div>
      </div>
    </section>

    <!-- App 介绍 -->
    <section class="app-intro content">
      <h2 class="section-title">App 介绍</h2>
      <div class="intro-text">
        <p>欢迎来到一席App。在这里，你可以自由地探索更加丰富的一席内容，包括过去10年的演讲、万象、枝桠、记录等。</p>
        <p>
          「探索」作为搜索功能衍生出的新生板块，提供了“话题”、“分类”、“专辑”以及“讲者”四个维度，方便你从兴趣与好奇心出发，在纷繁广袤的一席知识库中深入探寻。
        </p>
        <p>
          新增「我看」专区，用于建立属于你的个人媒体库。你可以收藏、缓存视频，也可以直观、快捷地找到自己拥有的课程和历史观看进度。
        </p>
        <p>
          你可以在观看视频和收听音频之间自由切换，并有专辑连播和定时关闭功能，更适合睡前聆听。阅读文稿、记忆播放、1080p超清投屏、赠送好友......还有更多功能等待你的发现。
        </p>
        <p>我们重视你的每一次使用体会，如有问题欢迎来信：</p>
        <ul class="contact-list">
          <li><span>邮箱：</span>yixitv@vip.163.com</li>
          <li><span>小编微信：</span>yixixiaobian</li>
          <li><span>微信公众号：</span>yixiclub</li>
        </ul>
      </div>
    </section>

    <!-- 新功能 -->
    <section class="app-features content">
      <h2 class="section-title">新功能</h2>
      <div class="feature-card">
        <div class="feature-version">版本 5.4.7</div>
        <h3 class="feature-title">跨学科视野再拓展，一席少年焕新上线</h3>
        <p>
          一席少年（YiXi Youth）迎来重要升级。作为一席的子品牌，我们始终相信，教育的边界远不止于课本。这一次，我们打破学科壁垒，以更敏锐的视角，为青少年、家长及教育者构建一个更立体的人文与科技知识场。
        </p>
        <p>升级即刻体验，和下一代一起，看见更广阔的世界。</p>
      </div>
    </section>

    <!-- 用户协议和隐私政策 -->
    <section class="app-links content">
      <router-link class="link-item" to="/about/userAgreement?type=more">用户协议</router-link>
      <span class="divider">|</span>
      <router-link class="link-item" to="/about/privacy?type=more">隐私政策</router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'YixiApp',
  data() {
    return {
      screenshots: [
        require('../assets/imgs/app/app01.png'),
        require('../assets/imgs/app/app02.png'),
        require('../assets/imgs/app/app03.png'),
        require('../assets/imgs/app/app04.png'),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.yixi-app-page {
  background-color: $C1;
}

.content {
  width: 80%;
  max-width: 1140px;
  margin: 0 auto;
  box-sizing: border-box;
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: $C3;
  margin: 0 0 20px;
}

/* 顶部介绍 */
.app-hero {
  background: linear-gradient(135deg, #151515 0%, #2d0c0c 45%, #7a1818 100%);
  padding: 60px 0;
  color: $C1;

  .hero-content {
    display: flex;
    align-items: center;
  }

  .app-icon {
    width: 120px;
    height: 120px;
    border-radius: 24px;
    overflow: hidden;
    margin-right: 30px;
    flex-shrink: 0;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .app-info {
    flex: 1;
  }

  .app-name {
    font-size: 36px;
    font-weight: 700;
    margin: 0 0 8px;
  }

  .app-slogan {
    font-size: 20px;
    font-weight: 500;
    margin: 0 0 8px;
    opacity: 0.95;
  }

  .app-subtitle {
    font-size: 14px;
    margin: 0 0 12px;
    opacity: 0.85;
  }

  .app-meta {
    font-size: 13px;
    opacity: 0.75;
  }
}

/* 信息栏 */
.app-stats {
  display: flex;
  justify-content: space-between;
  padding: 30px 0;
  border-bottom: 1px solid $C11;

  .stat-item {
    text-align: center;
    flex: 1;
    padding: 0 10px;
  }

  .stat-label {
    font-size: 12px;
    color: $C9;
    margin-bottom: 6px;
  }

  .stat-value {
    font-size: 20px;
    font-weight: 600;
    color: $C3;
    margin-bottom: 4px;
  }

  .stat-unit {
    font-size: 12px;
    color: $C4;
    line-height: 1.4;
  }

  .stat-icon {
    font-size: 18px;
  }

  .size-line {
    line-height: 1.6;
  }
}

/* 下载入口 */
.app-download {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 0;
  border-bottom: 1px solid $C11;

  .download-text {
    flex: 1;
  }

  .download-title {
    font-size: 24px;
    font-weight: 600;
    color: $C3;
    margin: 0 0 8px;
  }

  .download-subtitle {
    font-size: 14px;
    color: $C4;
    margin: 0 0 20px;

    .safe-tag {
      display: inline-flex;
      align-items: center;
      margin-left: 12px;
      font-size: 13px;
      color: $C4;

      .safe-icon {
        width: 14px;
        height: 14px;
        margin-right: 4px;
        color: $C2;
      }
    }
  }

  .download-btns {
    display: flex;
    gap: 16px;
  }

  .download-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 28px;
    border-radius: 24px;
    border: 1px solid $C5;
    color: $C2;
    text-decoration: none;
    font-size: 16px;
    font-weight: 400;
    transition: all 0.3s ease;
    line-height: 1;

    &:hover {
      background-color: $C2;
      color: $C1;
      border-color: $C2;

      .btn-icon {
        filter: brightness(0) invert(1);
      }
    }

    span {
      margin-right: 8px;
    }

    .btn-icon {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
  }

  .download-qrcode {
    flex-shrink: 0;
    margin-left: 40px;
    text-align: center;

    .qrcode-img {
      width: 130px;
      height: 130px;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .qrcode-tip {
      margin: 10px 0 0;
      font-size: 13px;
      color: $C4;
      line-height: 1;
    }
  }
}

/* 预览图 */
.app-screenshots {
  padding: 40px 0;

  .screenshots-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  .screenshot-card {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    background-color: $C10;

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
      display: block;
    }
  }
}

/* App 介绍 */
.app-intro {
  padding: 40px 0;
  border-top: 1px solid $C11;

  .intro-text {
    font-size: 15px;
    color: $C6;
    line-height: 1.8;

    p {
      margin: 0 0 16px;
    }
  }

  .contact-list {
    list-style: none;
    padding: 0;
    margin: 20px 0 0;

    li {
      margin-bottom: 8px;
      color: $C6;

      span {
        color: $C4;
        margin-right: 4px;
      }
    }
  }
}

/* 新功能 */
.app-features {
  padding: 40px 0;
  border-top: 1px solid $C11;

  .feature-card {
    background-color: $C10;
    border-radius: 16px;
    padding: 30px;
  }

  .feature-version {
    font-size: 12px;
    color: $C9;
    margin-bottom: 8px;
  }

  .feature-title {
    font-size: 18px;
    font-weight: 600;
    color: $C3;
    margin: 0 0 16px;
  }

  p {
    font-size: 15px;
    color: $C6;
    line-height: 1.8;
    margin: 0 0 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

/* 底部链接 */
.app-links {
  padding: 30px 0 50px;
  border-top: 1px solid $C11;
  text-align: center;
  font-size: 14px;
  color: $C4;

  .link-item {
    color: $C2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .divider {
    margin: 0 12px;
    color: $C5;
  }
}

@media (max-width: 1024px) {
  .app-screenshots {
    .screenshots-list {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 768px) {
  .app-hero {
    padding: 40px 0;

    .hero-content {
      flex-direction: column;
      text-align: center;
    }

    .app-icon {
      margin: 0 0 20px;
    }
  }

  .app-download {
    flex-direction: column;
    text-align: center;

    .download-btns {
      justify-content: center;
    }

    .download-qrcode {
      margin: 24px 0 0;
    }
  }

  .app-stats {
    flex-wrap: wrap;

    .stat-item {
      flex: 0 0 33.333%;
      margin-bottom: 20px;
    }
  }

  .app-screenshots {
    .screenshots-list {
      grid-template-columns: 1fr;
    }
  }
}
</style>
